import arraySample from './_arraySample.js';
import baseSample from './_baseSample.js';
import isArray from './isArray.js';

/**
 * Gets a random element from `collection`.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to sample.
 * @returns {*} Returns the random element.
 * @example
 *
 * _.sample([1, 2, 3, 4]);
 * // => 2
 */
function sample(collection) {
  var func = isArray(collection) ? arraySample : baseSample;
  return func(collection);
}

export default sample;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/sample.js
// module id = 497
// module chunks = 0